import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/** Logo CradleRewards: isotipo teal + wordmark (Bricolage Grotesque). */
@Component({
  selector: 'app-brand',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span class="mark" [style.width.px]="markSize()" [style.height.px]="markSize()">
      <cr-icon name="stamp" [size]="markSize() * 0.56" />
    </span>
    @if (!compact()) { <span class="word">CradleRewards</span> }
  `,
  styles: [`
    :host{display:inline-flex;align-items:center;gap:10px;color:var(--cr-text-primary)}
    .mark{display:grid;place-items:center;border-radius:28%;background:var(--cr-brand-teal);color:#fff;flex:none}
    .word{font:600 20px/24px var(--cr-font-display);letter-spacing:-.1px;white-space:nowrap}
  `],
})
export class BrandComponent {
  readonly compact = input(false);
  readonly markSize = input(32);
}
